import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import React, { useMemo } from 'react'

import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { NewsItem } from 'Types/emajinAPI'
import Utils from 'Utils'

import { useResponsiveLayout } from 'Hooks'

import Button from './Button'
import Card from './Card'
import { Container, Mask } from './styles'

type Props = {
  data?: NewsItem
}

function BlogPostGallery({ data }: Props) {
  const { isMobile } = useResponsiveLayout()

  const attachedImages = useMemo(
    () => Utils.Attachment.getAcceptableAttachment(data?.attachments),
    [data],
  )

  const slidesPerView = useMemo(() => {
    if (!attachedImages.length) return 0

    if (isMobile || attachedImages.length < 4) return 1

    return 3
  }, [attachedImages, isMobile])

  if (!data || !slidesPerView) return null

  return (
    <Container>
      <Swiper
        centeredSlides
        grabCursor
        loop
        modules={[Pagination]}
        pagination={{ clickable: true }}
        slidesPerView={slidesPerView}
        spaceBetween={16}
      >
        {!isMobile && attachedImages.length > 1 && (
          <>
            <Mask />
            <Button />
            <Button isNext />
          </>
        )}

        {attachedImages.map(item => (
          <SwiperSlide key={item.id}>
            <Card data={item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </Container>
  )
}

export default BlogPostGallery
